import { useContext } from 'react';

import { OSThemeAndContentContext } from './index';

export function useOSThemeAndContent() {
  return useContext(OSThemeAndContentContext);
}
